import { render, staticRenderFns } from "./ThemeButton.vue?vue&type=template&id=35c752f4"
import script from "./ThemeButton.vue?vue&type=script&lang=ts"
export * from "./ThemeButton.vue?vue&type=script&lang=ts"
import style0 from "./ThemeButton.vue?vue&type=style&index=0&id=35c752f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports